import { connect } from 'react-redux';
import * as R from 'ramda';

import {
  resetCardFilters,
  setFilters,
} from 'feature/loading-management/filters/store/filtersSlice';
import FilterPopover from './FilterPopover';
import {
  getCarrierOrLocationOptions,
  getStateOptions,
} from '../../store/carrierAuthorizationsSlice';

const mapState = state => ({
  authorizationSequencingPending:
    state.loadingManagement.carrierAuthorizations.carrierAuthorizationsPending,
  carrierOrLocationOptions: getCarrierOrLocationOptions(state),
  filters: R.o(R.pick(['nameShort', 'state']), R.path(['loadingManagement', 'filters']))(state),
  stateOptions: getStateOptions(state),
});

const mapDispatch = {
  resetCardFilters,
  setFilters,
};

export default connect(mapState, mapDispatch)(FilterPopover);
